import classNames from 'classnames';

import { useDreamComponentsContext } from '@/dreamComponentProvider/hooks';
import { formatPostTime } from '@/utils/post/utils';

import { postCardTimestamp } from '../Post.css';

const ALIGN_OPTIONS = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

interface Props {
  timestamp: string;
  timestampDisplay?: string;
  alignment?: 'left' | 'center' | 'right' | undefined;
  className?: string;
}

const Timestamp = ({ timestamp, timestampDisplay = 'short_date', alignment, className }: Props) => {
  const context = useDreamComponentsContext();
  return (
    <div className={classNames('flex', ALIGN_OPTIONS[alignment || 'left'], className)}>
      <span className={classNames(postCardTimestamp, 'text-xs w-fit whitespace-nowrap')}>
        {formatPostTime(timestamp, timestampDisplay, context.publicationTimeZone)}
      </span>
    </div>
  );
};

export default Timestamp;
